import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { SortOrder } from '@common/utils/search-sort';

export interface MailingReportItem {
  id: number;
  name: string;
  isActive: boolean;
}

export type MailingReportsList = MailingReportItem[];

export interface LastMailingReportsPageState {
  searchValue: string;
  sortOrder: SortOrder;
}

export interface MailingReportsState extends EntityState<MailingReportItem> {
  lastPageState: LastMailingReportsPageState;
  loading: boolean;
  error?: string;
}

export const mailingReportsAdapter = createEntityAdapter<MailingReportItem>({
  selectId: (item) => item.id as number,
});

export const initialStateMailingReports: MailingReportsState =
  mailingReportsAdapter.getInitialState({
    lastPageState: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
    },
    loading: false,
    error: undefined,
  });
